import * as React from 'react';
import { Responsive } from '@cian/ui-kit';

import { BackButtonDesktop } from './components/BackButtonDesktop';
import { BackButtonMobile } from './components/BackButtonMobile';

export interface IBackButtonProps {
  title: string;
  url: string;
}

export const BackButton: React.FC<IBackButtonProps> = ({ title, url }) => {
  return (
    <>
      <Responsive phone>
        <BackButtonMobile title={title} url={url} />
      </Responsive>
      <Responsive desktop tablet>
        <BackButtonDesktop title={title} url={url} />
      </Responsive>
    </>
  );
};
